import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import TabUtilities from "../../../../utilities/TabUtilities";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import TabGrid from "../../../../utilities/TabGrid"
import acc from "accounting";
import CheckboxFilter from "./filters/CheckboxFilter";
import PojazdFilter from "./filters/PojazdFilter";
import KierowcaFilter from "./filters/KierowcaFilter";
import StatusFilter from "./filters/StatusFilter";
import DataFilter from "./filters/DataFilter";
import LogowanieService from "../../../logowanie/LogowanieService";

export default class ZarzadzanieTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    componentWillMount() {
        let page = 1;
        if (localStorage.getItem('wynajmyPage') !== undefined && localStorage.getItem('wynajmyPage') !== null) {
            page = localStorage.getItem('wynajmyPage')
            localStorage.removeItem('wynajmyPage')
        }
        this.setState({page: page})
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                {/* <TopButtonPointAction onClick={() => {
                    this.props.handleWystawFakture(row)
                }} titleContent={'Wystaw fakturę dla pozycji'} buttonIcon={'fa fa-file-text-o'}/>*/}

                {
                    LogowanieService.sprawdzCzyZalogowanyPosiadaRole(['ROLE_WYNAJEM']) ?
                        <TopButtonPointEdit onClick={() => {
                            localStorage.setItem('wynajmyPage', this.state.page)
                            this.props.handleEdytuj(row);
                        }} titleContent={'Edytuj wynajem'}/>
                        :
                        <TopButtonPointAction onClick={() => {
                            localStorage.setItem('wynajmyPage', this.state.page)
                            this.props.handleEdytuj(row);
                        }}
                                              buttonIcon={'fa fa-eye'}
                                              titleContent={'Zobacz szczegóły'}
                                              buttonColor={'default'}

                        />
                }

                {/*<TopButtonPointRemove onClick={() => {
                    localStorage.setItem('wynajmyPage', this.state.page)
                    this.props.handleUsun(row)
                }} titleContent={'Usuń wynajem'}/>*/}
            </div>
        )
    }

    getKierowca(cell, row) {
        let kierowcy = [];
        if (row.wynajemKierowcy !== null) {
            for (let i = 0; i < row.wynajemKierowcy.length; i++) {
                kierowcy.push(" " + row.wynajemKierowcy[i].kierowca.imie + ' ' + row.wynajemKierowcy[i].kierowca.nazwisko)
            }
        }
        return kierowcy
    }

    getPojazd(cell, row) {
        if (row.pojazd === null) {
            return 'BRAK'
        } else {
            return row.pojazd.marka + " " + row.pojazd.model + " | " + row.pojazd.nrRej
        }

    }

    sprawdzZaplacono(cell, row) {
        if (row.zaplacono) {
            return <i className="fa fa-check" style={{color: '#58b13d'}}> </i>
        } else {
            return <i className="fa fa-remove" style={{color: '#cc0000'}}> </i>
        }
    }

    sprawdzFaktura(cell, row) {
        if (row.fakturaWystawiona) {
            return <i className="fa fa-check" style={{color: '#58b13d'}}> </i>
        } else {
            return <i className="fa fa-remove" style={{color: '#cc0000'}}> </i>
        }
    }

    formatStatus(cell, row) {
        if (row.status === 1) {
            return <div style={{
                background: '#eec24d',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: 5,
                fontSize: 10,
                textAlign: 'center',
                paddingTop: 2,
                paddingBottom: 2
            }}>ZAPYTANIE</div>
        } else {
            if (row.status === 2) {
                return <div style={{
                    background: '#f58989',
                    color: 'white',
                    fontWeight: 'bold',
                    borderRadius: 5,
                    fontSize: 10,
                    textAlign: 'center',
                    paddingTop: 2,
                    paddingBottom: 2
                }}>REZERWACJA</div>
            } else {
                if (row.status === 3) {
                    return <div style={{
                        background: '#7db6f3',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                        fontSize: 10,
                        textAlign: 'center',
                        paddingTop: 2,
                        paddingBottom: 2
                    }}>ZAMÓWIENIE</div>
                } else {
                    return <div style={{
                        background: '#7fd28c',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                        fontSize: 10,
                        textAlign: 'center',
                        paddingTop: 2,
                        paddingBottom: 2
                    }}>WYKONANO</div>
                }
            }
        }
    }

    handlePageChange(e) {
        this.setState({page: e})
    }

    renderCena(cell, row) {
        return acc.formatMoney(cell)
    }

    formatDate(cell) {
        return cell.substr(0, 10) + ' ' + cell.substr(11, 5)
    }

    getCustomFilter(filterHandler, customFilterParameters) {
        return (
            <CheckboxFilter filterHandler={filterHandler} textOK={customFilterParameters.textOK}
                            textNOK={customFilterParameters.textNOK}/>
        );
    }

    getPojazdFilter(filterHandler, customFilterParameters) {
        return (
            <PojazdFilter filterHandler={filterHandler}/>
        );
    }

    getDataFilter(filterHandler, customFilterParameters) {
        return (
            <DataFilter filterHandler={filterHandler}/>
        );
    }

    getKierowcaFilter(filterHandler, customFilterParameters) {
        return (
            <KierowcaFilter filterHandler={filterHandler}/>
        );
    }

    getStatusFilter(filterHandler, customFilterParameters) {
        return (
            <StatusFilter filterHandler={filterHandler}/>
        );
    }

    formatId(cell, row) {
        return <div style={{width: 25}}>{cell}</div>
    }

    render() {

        const options = {
            page: this.state.page,
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            defaultSortName: 'idWy',
            defaultSortOrder: 'desc',
            onPageChange: this.handlePageChange,
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idWy' dataFormat={this.formatId.bind(this)} thStyle={TabGrid.tg1} tdStyle={TabGrid.tg1} isKey>
                        <div style={{width: 25}}>ID</div>
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField='tytul'
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg3} tdStyle={TabGrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 200,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Tytuł</TableHeaderColumn>
                    <TableHeaderColumn dataField='klientNazwa'
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 200,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Klient</TableHeaderColumn>
                    <TableHeaderColumn dataField='miejsceOd'
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 200,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Miejsce od</TableHeaderColumn>
                    <TableHeaderColumn dataField='miejsceDo'
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 200,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Miejsce do</TableHeaderColumn>
                    <TableHeaderColumn dataField='status' dataFormat={this.formatStatus.bind(this)}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={{type: 'CustomFilter', getElement: this.getStatusFilter}}
                    >Status</TableHeaderColumn>
                    <TableHeaderColumn dataField='pojazd' dataFormat={this.getPojazd.bind(this)}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={{type: 'CustomFilter', getElement: this.getPojazdFilter}}
                    >Samochód</TableHeaderColumn>
                    <TableHeaderColumn dataField='wynajemKierowcy' dataFormat={this.getKierowca.bind(this)}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={{type: 'CustomFilter', getElement: this.getKierowcaFilter}}
                    >Kierowca</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataOd' dataFormat={this.formatDate.bind(this)}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={{
                                           type: 'CustomFilter',
                                           getElement: this.getDataFilter,
                                           customFilterParameters: {textOK: 'Tak', textNOK: 'Nie'}
                                       }}
                    >Data od</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataDo' dataFormat={this.formatDate.bind(this)}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={{
                                           type: 'CustomFilter',
                                           getElement: this.getDataFilter,
                                           customFilterParameters: {textOK: 'Tak', textNOK: 'Nie'}
                                       }}
                    >Data do</TableHeaderColumn>
                    <TableHeaderColumn dataField='cenaNajmu' dataFormat={this.renderCena.bind(this)}
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg2} tdStyle={TabGrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 200,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Cena</TableHeaderColumn>
                    <TableHeaderColumn dataField='zaplacono'
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg1} tdStyle={TabGrid.tg1}
                                       dataFormat={this.sprawdzZaplacono.bind(this)}
                                       filter={{
                                           type: 'CustomFilter',
                                           getElement: this.getCustomFilter,
                                           customFilterParameters: {textOK: 'Tak', textNOK: 'Nie'}
                                       }}
                    ><span style={{fontSize: '12px'}}>Zapłacono</span></TableHeaderColumn>
                    <TableHeaderColumn dataField='fakturaWystawiona'
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg1} tdStyle={TabGrid.tg1}
                                       dataFormat={this.sprawdzFaktura.bind(this)}
                                       filter={{
                                           type: 'CustomFilter',
                                           getElement: this.getCustomFilter,
                                           customFilterParameters: {textOK: 'Tak', textNOK: 'Nie'}
                                       }}
                    ><span style={{fontSize: '12px'}}>Faktura</span></TableHeaderColumn>
                    <TableHeaderColumn dataField='idWy'
                                       hidden={(Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}
                                       thStyle={TabGrid.tg1} tdStyle={TabGrid.tg1}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjaDowolnaHtml('Edytuj', 'grey')}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}











// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/ZarzadzanieTable.js